import { Step1, Step2 } from "@/components/organization/form";
import { Styled } from "./styles";
import { withErrorBoundary } from "@/components/hoc";
import { Box, Button, useTheme } from "@mui/material";
import Copyright from "@/components/layout/copyright";
import HeaderTop from "@/components/layout/header-top";
import React, { useRef, useState } from "react";
import { Forms } from "@/types/form";
import { ArrowBack } from "@dippi/icons";

const Page: React.FC = () => {
    const theme = useTheme();

    const [step, setStep] = useState(1);
    const [state, setState] = useState<{
        step1: Forms["OrganizationStep1"] | null;
        step2: Forms["OrganizationStep2"] | null;
    }>({
        step1: null,
        step2: null,
    });
    const onBack = useRef(() => setStep(step => step - 1));

    return (
        <React.Fragment>
            <Box position="fixed" width="100%" zIndex={99}>
                <HeaderTop />
            </Box>
            <Box minHeight="56px" maxHeight="56px" />
            <Styled.Container>
                <Box>
                    {step === 2 ? (
                        <Box
                            display="inline-flex"
                            alignItems="center"
                            onClick={() => onBack.current()}
                            sx={{ cursor: "pointer" }}
                        >
                            <ArrowBack fill={theme.palette.primary.main} />
                            <Button
                                variant="text"
                                sx={{ minWidth: "0", marginLeft: "5px" }}
                                data-testid="organization-back-button"
                            >
                                Back
                            </Button>
                        </Box>
                    ) : null}
                    <Styled.Content>
                        {step === 1 ? (
                            <Step1 setStep={setStep} state={state} setState={setState} />
                        ) : step === 2 ? (
                            <Step2
                                setStep={setStep}
                                state={state}
                                setState={setState}
                                onBack={onBack}
                            />
                        ) : null}
                    </Styled.Content>
                    <Copyright isAuth={true} />
                </Box>
            </Styled.Container>
        </React.Fragment>
    );
};

export default withErrorBoundary({ component: "Organization" })(Page);
